export const VERIFIED = 'VERIFIED';
export const FAILED_VERIFICATION = 'FAILED_VERIFICATION';
export const PENDING_REVIEW = 'PENDING_REVIEW';
export const INITIAL = 'INITIAL';
